import { useCallback, useEffect } from "react";
import useEmblaCarousel from "embla-carousel-react";
import PagesController from "./PagesController";
import ParagraphsCarousel from "./ParagraphsCarousel";
import { ScratchInstructions } from "utils/interfaces";
import { EmblaCarouselType } from "embla-carousel";

interface ParagraphsProps {
  instructions: ScratchInstructions[];
  activeFullCodeImage: string;
  setShowCodeFullscreen: React.Dispatch<React.SetStateAction<boolean>>;
  setInitialCodeTab: React.Dispatch<React.SetStateAction<number>>;
  selectedIndex: number;
  setSelectedIndex: React.Dispatch<React.SetStateAction<number>>;
}

const Paragraphs: React.FC<ParagraphsProps> = ({
  instructions,
  activeFullCodeImage,
  setShowCodeFullscreen,
  setInitialCodeTab,
  selectedIndex,
  setSelectedIndex,
}) => {
  // Carousel states
  const [emblaRef, emblaApi] = useEmblaCarousel({
    axis: "y",
    loop: false,
    align: "start",
    containScroll: "trimSnaps",
  });

  /**
   * Function used to init the scroll list
   */
  const onInit = useCallback(
    (emblaApi: EmblaCarouselType) => {
      // And move straight into the current index
      emblaApi.scrollTo(selectedIndex);
    },
    [selectedIndex],
  );

  /**
   * Function used to update the index of the point when a
   * different slide is selected (from the scrolling slides
   * instead of the up and down buttons)
   */
  const onSelect = useCallback((emblaApi: EmblaCarouselType) => {
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    onInit(emblaApi);
    emblaApi.on("reInit", onInit).on("select", onSelect);
  }, [emblaApi, onInit, onSelect]);

  return (
    <>
      <PagesController
        emblaApi={emblaApi}
        instructions={instructions}
        activeFullCodeImage={activeFullCodeImage}
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
        setShowCodeFullscreen={setShowCodeFullscreen}
        setInitialCodeTab={setInitialCodeTab}
      />
      <ParagraphsCarousel
        emblaRef={emblaRef}
        instructions={instructions}
        selectedIndex={selectedIndex}
      />
    </>
  );
};

export default Paragraphs;
